import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GooglePlaceAddress } from 'src/app/_core/models/Address';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss'],
})
export class RegionComponent implements OnInit {
  @Output() searchAddress: EventEmitter<GooglePlaceAddress> = new EventEmitter<GooglePlaceAddress>();

  constructor() {}

  ngOnInit(): void {}

  handleAddressChange(address: GooglePlaceAddress): void {
    this.searchAddress.emit(address);
  }
}
